import SearchForm from "../../Common/SearchForm";
import InputText from "../../Common/InputText";
import { useEffect } from "react";
import { connect } from "react-redux";
import {
  updateExportDestination,
  requestCaseSearch,
  updateCaseCriteria,
  REQUEST_CASE_SEARCH,
} from "../../Store/mutations";
import ToastContainer from "../../components/Toast/ToastContainer";

const ExportSearchForm = ({
  configurationIds,
  configurationNames,
  selectedDestination,
  updateSelectedDestination,
  requestCaseSearch,
  caseSearchNumber,
}) => {
  useEffect(() => {
    requestCaseSearch();
  }, [requestCaseSearch]);

  const sanitize = (caseNumber) => {
    if (caseNumber.length === 0) return caseNumber;
    caseNumber = caseNumber.replaceAll("+", "");
    caseNumber = caseNumber.replaceAll("\\", "");
    caseNumber = caseNumber.replaceAll("/", "");
    while (caseNumber[0] === ".") {
      caseNumber = caseNumber.substring(1);
    }
    return caseNumber.trim();
  };
  return (
    <>
      <SearchForm id="exportControl" title={`Export Control`}>
        <label>Export To:</label>
        <div>
          <select
            aria-label="ExportDestination"
            defaultValue={selectedDestination}
            onChange={({ target }) => updateSelectedDestination(target.value)}
          >
            <option disabled value="default">
              Choose destination
            </option>
            {configurationIds.map((id) => {
              const hasName =
                configurationNames &&
                typeof configurationNames === "object" &&
                configurationNames[id] &&
                typeof configurationNames[id] === "string" &&
                configurationNames[id].trim() !== "";

              return (
                <option value={id} key={id}>
                  {hasName ? configurationNames[id] : id}
                </option>
              );
            })}
          </select>
        </div>

        <InputText
          aria-label="caseNumberFilter"
          action={REQUEST_CASE_SEARCH}
          collection="caseCriteria"
          id="caseNumber"
          label="Case Number"
          tooltip={`Use Case Number to narrow down the results`}
          placeholder={`Enter Case Number`}
          value={caseSearchNumber}
          sanitize={sanitize}
        />
      </SearchForm>

      <ToastContainer screenName="ExportsSearchForm" />
    </>
  );
};

const mapStateToProps = (state) => ({
  officers: state.officers,
  configurationIds: state.genericExportOptions.configurationIds,
  configurationNames: state.genericExportOptions.configurationNames,
  selectedDestination: state.genericExportOptions.selectedDestination,
  caseSearchNumber: state.caseCriteria.caseNumber,
});

const mapDispatchToProps = (dispatch) => ({
  updateSelectedDestination: (value) =>
    dispatch(updateExportDestination(value)),
  requestCaseSearch: () => dispatch(requestCaseSearch()),
  updateCaseCriteria: (value) => dispatch(updateCaseCriteria(value)),
});

const ConnectedExportSearchForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(ExportSearchForm);
export default ConnectedExportSearchForm;
